<template>
  <v-container fluid>
    <v-row class="pl-4">
      <v-col>
        <v-dialog
            v-model="addWasteTypeDialog"
            width="500"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="primary"
                v-bind="attrs"
                v-on="on"
            >
              New Waste Type
            </v-btn>
          </template>

          <v-card>
            <v-container>
              <v-row>
                <v-col>
                  <h3 class="primary--text">
                    Please select a waste type
                  </h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                      v-model="selectedWasteType"
                      :items="availableWasteTypes"
                      item-text="name"
                      item-value="key"
                      label="Select waste type"
                      return-object
                      single-line
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-row justify="end" class="pr-4">
                <v-btn color="primary" v-on:click="addWasteType">Save</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getFirestore, arrayUnion, updateDoc, doc } from 'firebase/firestore';
const db = getFirestore();

export default {
  name: "AddWasteType",
  props: {
    serviceAreaId: String,
    getWasteTypes: Function,
    assignedWasteTypes: Array
  },
  data() {
    return {
      isDataLoaded: false,
      addWasteTypeDialog: false,
      selectedWasteTypes: [],
      availableWasteTypes: []
    }
  },
  methods: {
    addWasteType() {
      let promises = [];
      const docRef = doc(db, 'service-provider-areas', this.serviceAreaId);
      const promise = updateDoc(docRef, {
        wasteTypes: arrayUnion({
          key: this.selectedWasteType.key,
          name: this.selectedWasteType.name
        })
      })
      promises.push(promise);
      Promise.all(promises)
      .then(() => {
        this.$router.go();
      })
      .catch((error) => {
        alert(`Could not update service area: ${error.message}`)
        this.$router.go();
      });
    },
    isWasteTypeEqual(one, two) {
      return one.key === two.key;
    },
    findExcludedElements(fullset, subset, compareElement) {
      let excluded = [];
      fullset.forEach((element) => {
        const maybeElement = subset.find((el) => {
          return compareElement(el, element)
        });
        if (!maybeElement) {
          excluded.push(element);
        }
      });
      return excluded;
    }
  },
  async updated() {
    if(!this.isDataLoaded) {
      const wasteTypes = await this.getWasteTypes();

      this.availableWasteTypes = this.findExcludedElements(
          wasteTypes,
          this.assignedWasteTypes,
          this.isWasteTypeEqual
      );
      this.isDataLoaded = true;
    }
  },
  async mounted() {

  }
}
</script>

<style scoped>

</style>